export default function access(initialState: { currentUser?: API.CurrentUser } | undefined) {
  
  const { currentUser } = initialState ?? {};
  const staff = currentUser && currentUser.userType !== 0;
  const student = currentUser && currentUser.userType === 0;

  return {
    canAdmin: currentUser && currentUser.roles.includes('Admin'),
    staff,
    student
  };
}
